import Handlebars from '@sparta.global.vendors/handlebars';
import { badgingHelper } from '@sparta.global.helpers/badging-helper/dist/es5.js';
import { svgHelper } from '@sparta.global.helpers/svg-helper/dist/es5.js';

/**
 * @const {object} helpers
 * @description Exposes our Handlebars helper and the name we'll call it by.
 */

var ACTION_MODIFIERS = {
  layer: 'spa-ui-layer-link spa-fn',
  popup: 'spa-fn spa-boa-window'
};
var ACTION_LAYER_MODIFIERS = {
  interstitialType: 'spa-ui-layer-interstitial',
  inputHelpLinkType: 'toggle-trigger-link',
  inputHelpIconType: 'toggle-trigger svg-button',
  layerType: 'spa-ui-layer-tooltip-link'
};

/**
   * @method helpers.circleButton
   * @param {object} jcr JSON object used to build the circle button.
   * @returns {Node} `Handlebars.SafeString` version of `circle button` element.
   * @description Creates circle button from options provided.
   */
function circleButton(jcr) {
  if (!jcr) {
    throw new Error('No circle button JCR objects provided to helpers-circle-button.');
  }

  // Set defaults if JCR options do not exist.
  var label = jcr.label ? jcr.label : '';
  var userClasses = jcr.classes ? jcr.classes : [];
  var attributes = jcr.attributes ? jcr.attributes : {};
  var adaText = jcr.adaText ? jcr.adaText : '';
  jcr.content || '';
  var badging = '';
  var cssBadging = 'spa-circle-btn--has-badge';
  var iconDataJcr = '';
  var allClasses = '';
  userClasses.forEach(function (userClass) {
    allClasses += "".concat(userClass, " ");
  });
  var attributeKeys = jcr.attributes ? Object.keys(jcr.attributes) : [];
  var allAttributes = '';
  var excludeRoleAttribute = [];

  //remove role attribute from JCR if present
  excludeRoleAttribute = attributeKeys.filter(function (val) {
    return val.indexOf('role') < 0;
  });
  excludeRoleAttribute.forEach(function (key) {
    if (key === 'disabled' && attributes.disabled === true) {
      allAttributes += " disabled";
    } else {
      allAttributes += " ".concat(key, "=\"").concat(attributes[key], "\"");
    }
  });

  // actionType
  // (for triggering global ui-layers stuff: modals, interstitials, popups, etc)
  if (jcr.actionType) {
    var type = jcr.actionType.type;
    var options = jcr.actionType.options;

    // add tracking attribute
    allAttributes += 'data-bactmtrack ';
    if (options) {
      // add stringified, escaped options as an attribute
      var stringifiedOptions = JSON.stringify(jcr.actionType.options);
      var escapedOptions = Handlebars.Utils.escapeExpression(stringifiedOptions);
      allAttributes += "data-options=\"".concat(escapedOptions, "\" ");
    }

    // function map to handle the main action types (layer | popup)
    // note: type 'popup' has no specific handling requirements anymore
    var typeSwitch = {
      layer: function layer() {
        if (options) {
          if (options.rel) {
            allAttributes += "rel=\"".concat(options.rel, "\" ");
          }

          // add 'layer' subtype-based modifiers
          Object.keys(ACTION_LAYER_MODIFIERS).some(function (key) {
            if (options.hasOwnProperty(key)) {
              allClasses += ACTION_LAYER_MODIFIERS[key] + ' ';
              return true;
            }
            return false;
          });
        }
      }
    };
    if (type) {
      // add type-based modifiers
      if (ACTION_MODIFIERS.hasOwnProperty(type)) {
        allClasses += ACTION_MODIFIERS[type] + ' ';
      }
      // execute the function map
      if (typeSwitch[type]) {
        typeSwitch[type]();
      }
    }
  }
  if (jcr.selected) {
    allClasses += 'spa-circle-btn--selected ';
  }

  // add badging
  if (jcr.badging) {
    allClasses += "".concat(cssBadging, " ");
    jcr.badging.options = jcr.badging.options || {};
    jcr.badging.options.position = 'absolute';
    if (jcr.badging.type === 'numeric' && jcr.badging.content) {
      adaText += jcr.badging.content;
    }
    adaText += jcr.badging.options.ariaLabel ? jcr.badging.options.ariaLabel : '';
    badging = badgingHelper(jcr.badging);
  }

  //add icon 
  if (jcr.icon) {
    iconDataJcr = "".concat(svgHelper({
      type: 'static',
      iconName: jcr.icon,
      classes: "spa-circle-btn-icon",
      focusable: 'false',
      ariaHidden: true
    }));
  }
  var circleButton = "\n  <button\n    type=\"button\"\n    ".concat(jcr.vueOptionsStr || '', "\n    class=\"spa-circle-btn-wrapper ").concat(allClasses, "\"\n    ").concat(allAttributes, "\n  >\n    <span class=\"spa-circle-btn\" aria-hidden=\"true\">\n      ").concat(iconDataJcr, "\n      ").concat(badging, "\n    </span>\n    <span class=\"spa-circle-btn-label\">\n      ").concat(label, "\n      <span class=\"spa-ada-text ada-hidden\">").concat(adaText, "</span>\n    </span>\n  </button>\n");
  return new Handlebars.SafeString(circleButton);
}
export { circleButton };